// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * LCC API
 * API for the LCC backend
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { Meta } from './Meta';
import {
    MetaFromJSON,
    MetaFromJSONTyped,
    MetaToJSON,
    MetaToJSONTyped,
} from './Meta';
import type { Room } from './Room';
import {
    RoomFromJSON,
    RoomFromJSONTyped,
    RoomToJSON,
    RoomToJSONTyped,
} from './Room';

/**
 * 
 * @export
 * @interface RoomList
 */
export interface RoomList {
    /**
     * 
     */
    data?: Array<Room>;
    /**
     * 
     */
    meta?: Meta;
}

/**
 * Check if a given object implements the RoomList interface.
 */
export function instanceOfRoomList(value: object): value is RoomList {
    return true;
}

export function RoomListFromJSON(json: any): RoomList {
    return RoomListFromJSONTyped(json, false);
}

export function RoomListFromJSONTyped(json: any, ignoreDiscriminator: boolean): RoomList {
    if (json == null) {
        return json;
    }
    return {
        
        'data': json['data'] == null ? undefined : ((json['data'] as Array<any>).map(RoomFromJSON)),
        'meta': json['meta'] == null ? undefined : MetaFromJSON(json['meta']),
    };
}

export function RoomListToJSON(json: any): RoomList {
    return RoomListToJSONTyped(json, false);
}

export function RoomListToJSONTyped(value?: RoomList | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': value['data'] == null ? undefined : ((value['data'] as Array<any>).map(RoomToJSON)),
        'meta': MetaToJSON(value['meta']),
    };
}

